/**
 * Enum che rappresenta gli stati possibili di un Lead.
 * Allineato con i valori `Type` dell'entità LeadStatus sul backend.
 */
export enum LeadStatusEnum {
  NUOVO        = 1,
  IN_GESTIONE  = 2,
  CHIUSO       = 3,
  COMPLETATO   = 4,
  FALLITO      = 5,
  CANCELLATO   = 6
}
